import { Injectable } from "@angular/core";
import { CustomEntityCollectionServiceBase } from "@app/core/ngrx/entity-services/custom-entity-collection-service-base";
import { ApiService } from "@app/core/services/api/api.service";
import { County } from "@app/models/county";
import { EntityCollectionServiceElementsFactory } from "@ngrx/data";
import { catchError, map } from "rxjs";

@Injectable({ providedIn: "root" })
export class CountyService extends CustomEntityCollectionServiceBase<County> {
  constructor(
    serviceElementsFactory: EntityCollectionServiceElementsFactory,
    private apiService: ApiService
  ) {
    super("County", serviceElementsFactory);
  }

  // @ts-ignore
  getWithQuery = (params: any) => {
    this.setLoading(true);
    return this.apiService.get("counties/search", params).pipe(
      map((response: any) => {
        this.setLoading(false);
        this.upsertManyInCache(response.counties);
        this.setListDefaults(response.counties);
        return response.counties;
      }),
      catchError((err) => err)
    );
  };
}
